import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { v4 as uuidv4 } from "uuid";
import toast from "react-hot-toast";

type uploadedDocument = string;
export interface GlobalState {
  open: boolean;
  chatStarted: boolean;
  searchModal: boolean;
  messages: Array<string>;
  input: string;
  darkMode: boolean;
  chats: any[];
  chatId: string | null;
  caption: boolean;
  settings: boolean;
  captionPopUp: boolean;
  isLoading: boolean;
  uploadedDocuments: uploadedDocument[][];
  shareModal: boolean;
  sharedToken: string;
  shareChatId: string | null;
  sharedChats: any[];
}

const initialState: GlobalState = {
  open: false,
  chatStarted: false,
  searchModal: false,
  messages: [],
  input: "",
  darkMode: false,
  chats: [],
  chatId: null,
  caption: false,
  settings: false,
  isLoading: false,
  captionPopUp: false,
  uploadedDocuments: [],
  shareModal: false,
  sharedToken: "",
  shareChatId: null,
  sharedChats: [],
};

export const GlobalSlice = createSlice({
  initialState,
  name: "globalstate",
  reducers: {
    setOpen: (state, action) => {
      state.open = action.payload;
    },
    setChatStarted: (state, action) => {
      state.chatStarted = action.payload;
    },
    setSearcModal: (state, action) => {
      state.searchModal = action.payload;
    },
    setMessage: (state, action) => {
      state.messages = action.payload;
    },
    setSelectedInput: (state, action) => {
      state.input = action.payload;
    },
    setDarkMode: (state, action) => {
      state.darkMode = action.payload;
    },
    // Redux Reducers
    setChats: (state, action) => {
      state.chats.push(action.payload);
    },

    addUploadedDocuments: (
      state,
      action: PayloadAction<uploadedDocument[]>
    ) => {
      if (action.payload.length > 0) {
        state.uploadedDocuments.push(action.payload);
      }
    },
    clearDocuments: (state) => {
      state.uploadedDocuments = [];
    },
    updateChat: (state, action) => {
      const index = state.chats.findIndex((msg) => msg.isLoading);
      if (index !== -1) {
        state.chats[index] = {
          id: uuidv4(),
          sender: "assistant",
          content: action.payload,
        };
      } else {
        state.chats.push({
          id: uuidv4(),
          sender: "assistant",
          content: action.payload,
        });
      }
      state.isLoading = false;
    },

    replaceEditedMessages: (state, action) => {
      const { userMessageIndex, newUserContent, assistantContent } =
        action.payload;

      if (state.chats[userMessageIndex]?.sender === "user") {
        // Replace user message
        state.chats[userMessageIndex].content = newUserContent;
      }

      // Assuming assistant message is right after user message
      if (state.chats[userMessageIndex + 1]?.sender === "assistant") {
        state.chats[userMessageIndex + 1].content = assistantContent;
      }

      state.isLoading = false;
    },

    // streamin redux
    // updateChat: (state, action) => {
    //   state.isLoading = false;

    //   // Check if the last message is from the assistant
    //   const lastMessage = state.chats[state.chats.length - 1];

    //   if (lastMessage && lastMessage.sender === "assistant") {
    //     // If the last message is from the assistant, append new text to it
    //     lastMessage.content = action.payload;
    //   } else {
    //     // Otherwise, add a new assistant message
    //     state.chats.push({
    //       id: uuidv4(),
    //       sender: "assistant",
    //       content: action.payload,
    //     });
    //   }
    // },

    addLoadingState: (state) => {
      if (!state.isLoading) {
        state.isLoading = true;
        // state.chats.push({ sender: "assistant", isLoading: true, content: "" });
      }
    },
    setLoadingOnEditedAssistant: (state, action) => {
      const assistantIndex = action.payload;

      if (state.chats[assistantIndex]?.sender === "assistant") {
        state.chats[assistantIndex] = {
          ...state.chats[assistantIndex],
          content: "", // or "Loading..."
          isLoading: true,
        };
      }
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    passPreviouseChats: (state, action) => {
      state.chats = action.payload;
      state.isLoading = false;
    },
    passSharedChats: (state, action) => {
      state.sharedChats = action.payload;
    },
    clearChats: (state) => {
      state.chats = [];
      state.sharedChats = [];
      state.messages = [];
      state.chatId = null;
    },
    clearOnlyChats: (state) => {
      state.chats = [];
      // state.sharedChats = [];
      state.messages = [];
      state.chatId = null;
    },
    setChatId: (state, action) => {
      state.chatId = action.payload;
    },
    setLiveCaption: (state, action) => {
      state.caption = action.payload;
    },
    setLiveCaptionPopUp: (state, action) => {
      state.captionPopUp = action.payload;
    },
    setSettings: (state, action) => {
      state.settings = action.payload;
    },
    setShareModal: (state, action) => {
      state.shareModal = action.payload;
    },
    setSharedToken: (state, action) => {
      state.sharedToken = action.payload;
    },
    setSharedChatId: (state, action) => {
      state.shareChatId = action.payload;
    },
  },
});

export const {
  setOpen,
  setChatStarted,
  setSearcModal,
  setMessage,
  setSelectedInput,
  setDarkMode,
  setChats,
  setSharedChatId,
  setChatId,
  setLiveCaption,
  replaceEditedMessages,
  setSettings,
  clearOnlyChats,
  setIsLoading,
  setSharedToken,
  setLiveCaptionPopUp,
  setShareModal,
  updateChat,
  addLoadingState,
  clearChats,
  passPreviouseChats,
  addUploadedDocuments,
  setLoadingOnEditedAssistant,
  clearDocuments,
  passSharedChats,
} = GlobalSlice.actions;

export const SelectOpenState = (state: RootState) => state.globalstate.open;
export const startChat = (state: RootState) => state.globalstate.chatStarted;
export const openModal = (state: RootState) => state.globalstate.searchModal;
export const selectMessages = (state: RootState) => state.globalstate.messages;
export const selectInput = (state: RootState) => state.globalstate.input;
export const selectDarkmode = (state: RootState) => state.globalstate.darkMode;
export const selectChat = (state: RootState) => state.globalstate.chats;
export const selectChatId = (state: RootState) => state.globalstate.chatId;
export const showCaption = (state: RootState) => state.globalstate.caption;
export const showShareModal = (state: RootState) =>
  state.globalstate.shareModal;
export const showCaptionPopUp = (state: RootState) =>
  state.globalstate.captionPopUp;
export const showSettings = (state: RootState) => state.globalstate.settings;
export const selectSharedToken = (state: RootState) =>
  state.globalstate.sharedToken;
export const selectDocuments = (state: RootState) =>
  state.globalstate.uploadedDocuments;
export const selectSharedChatId = (state: RootState) =>
  state.globalstate.shareChatId;
export const selectSharedChats = (state: RootState) =>
  state.globalstate.sharedChats;
export const GlobalReducer = GlobalSlice.reducer;
